import { useParams } from "react-router-dom";
import { isTaskSaleAdditional } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { SalePage } from "./SalePage";

const Sale = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskSaleAdditional(currentTask) || !currentPoint)
        return <NotFound />;

    return <SalePage point={currentPoint} task={currentTask} />;
};

export default Sale;
